import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Range fills use linkSubtle
// (legacy mainLargeText_20 — light value is verbatim #3876AA33).
const makeStyles = colors =>
  StyleSheet.create({
    headerContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    buttonContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    buttonHitSlop: {
      top: 8,
      right: 8,
      bottom: 8,
      left: 8,
    },
    dayNameContainer: {
      flexDirection: 'row',
      marginTop: 16,
      marginBottom: 10,
    },
    setFlex: {
      flex: 1,
    },
    selectedDateContainer: {
      backgroundColor: colors.transparent,
      borderRadius: 0,
      borderTopRightRadius: 16,
      borderBottomRightRadius: 16,
      width: '100%',
    },
    startDateContainer: {
      backgroundColor: colors.linkSubtle,
      borderRadius: 0,
      borderTopLeftRadius: 16,
      borderBottomLeftRadius: 16,
      width: '100%',
    },
    endDateContainer: {
      backgroundColor: colors.linkSubtle,
      borderRadius: 0,
      borderTopRightRadius: 16,
      borderBottomRightRadius: 16,
      width: '100%',
    },
    selectedDayText: {
      color: colors.textOnAccent,
      fontWeight: '600',
      backgroundColor: colors.accentStrong,
      textAlign: 'center',
      width: '50%',
      marginTop: 4,
      marginBottom: 4,
      paddingTop: 3,
      aspectRatio: 1,
      borderRadius: 12,
      overflow: 'hidden',
    },
    singleDayText: {
      color: colors.textOnAccent,
      fontWeight: '600',
      backgroundColor: colors.textPrimary,
      textAlign: 'center',
      width: '50%',
      marginTop: 4,
      marginBottom: 4,
      paddingTop: 3,
      aspectRatio: 1,
      borderRadius: 12,
      overflow: 'hidden',
    },
    middleDayContainer: {
      backgroundColor: colors.linkSubtle,
      borderRadius: 0,
      width: '100%',
    },
    middleDayText: {
      color: colors.textPrimary,
      fontWeight: '600',
    },
  });

export default makeStyles;
